var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99999C0 3.58171 3.58172 0 8 0H432C436.418 0 440 3.58172 440 8V432C440 436.418 436.418 440 432 440H7.99999C3.58171 440 0 436.418 0 432V7.99999Z",
    fill: "#FAFBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.893 125.303C120.893 123.239 122.869 121.748 124.854 122.315L219.216 149.276C219.653 149.401 220.106 149.464 220.56 149.464H316C317.716 149.464 319.107 150.855 319.107 152.571V314.697C319.107 316.761 317.131 318.252 315.146 317.685L220.784 290.724C220.347 290.599 219.894 290.536 219.44 290.536H124C122.284 290.536 120.893 289.145 120.893 287.429V125.303Z",
    fill: "#FCFDFC",
    stroke: "#E9FAEE",
    strokeWidth: 1.78571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.893 314.697C120.893 316.761 122.869 318.252 124.854 317.685L219.216 290.724C219.653 290.599 220.106 290.536 220.56 290.536H316C317.716 290.536 319.107 289.145 319.107 287.429V125.303C319.107 123.239 317.131 121.748 315.146 122.315L220.784 149.276C220.347 149.401 219.894 149.464 219.44 149.464H124C122.284 149.464 120.893 150.855 120.893 152.571V314.697Z",
    fill: "#FCFDFC",
    stroke: "#E9FAEE",
    strokeWidth: 1.78571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.352 239.855V199.513H201.552L202.294 229.113L195.037 199.513H185.494V239.855H192.466L191.837 209.627L198.98 239.855H208.352ZM233.837 205.741V199.513H214.066V239.855H221.552V221.855H233.094V215.855H221.552V205.741H233.837ZM258.221 205.341V199.513H235.821V205.341H243.249V239.855H250.735V205.341H258.221Z",
    fill: "#B6D6C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftCover);
export default __webpack_public_path__ + "static/media/nft_cover.e66fc7a5ab279a331c500d641fd398d9.svg";
export { ForwardRef as ReactComponent };